import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'
import { useCheckboxProps } from '../../hooks/useCheckboxProps'

type OmittedChakraCheckboxProps =
  | 'colorScheme'
  | 'icon'
  | 'iconColor'
  | 'iconSize'
  | 'variant'
  | 'disabled'

export type CheckboxProps = Omit<
  SwashbuckleComponentProps<ChakraCheckboxProps>,
  OmittedChakraCheckboxProps
>

export const Checkbox = (props: CheckboxProps) => {
  const checkboxProps = useCheckboxProps(props)

  return <ChakraCheckbox {...checkboxProps} />
}

Checkbox.displayName = 'Checkbox'
